import React, { useState, useEffect } from 'react';
import { keyFacts as staticKeyFacts } from '../../utils/utils.statiquedata';
import { APPNAME } from '../../utils/utils.constants';
import { PageSectionHeader } from './PageSectionHeader';
import { Colors } from '../../utils/utils.colors';
import { apiGet } from '../../utils/api';

export const WhyChooseUs: React.FC = () => {
    const [stats, setStats] = useState<KeysFacts[]>([]);

    useEffect(() => {
        apiGet('/key-facts', { activeOnly: 'true' })
            .then((res) => {
                const rows: KeysFacts[] = res.rows || [];
                setStats(rows.slice(0, 4));
            })
            .catch(() => setStats(staticKeyFacts.slice(0, 4)));
    }, []);

    return (
        <section className="static w-full px-4 mb-8 md:absolute md:bottom-0 md:left-1/2 md:-translate-x-1/2 md:translate-y-[80%] md:z-30 md:max-w-7xl md:px-8">
            <div className="bg-white rounded-xl- shadow-2xl p-10 md:p-16 border border-gray-100 py-4 px-3">

                <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14 mb-0 pb-0">
                    <PageSectionHeader
                        eyebrow={`Pourquoi nous`}
                        title={`Pourquoi choisir l'${APPNAME} ?`}
                        lead="L’ULPGL est l’université de référence dans la région des Grands Lacs.
                        Découvrez quelques chiffres clés qui témoignent de notre excellence académique"
                        align="center"
                    />
                </div>

                <div className="grid grid-cols-1 divide-y divide-gray-200 sm:grid-cols-2 sm:divide-y-0 sm:divide-x lg:grid-cols-4 gap-0 py-2">
                    {stats.map((stat, idx) => (
                        <div key={idx} className="p-2 flex flex-col items-center justify-start h-full w-full px-6 text-center">
                            <div className="flex items-end justify-center w-full min-h-[50px] mb-1">
                                <div className="text-3xl md:text-4xl font-extrabold- page-section-header__title" style={{ color: Colors.primaryColor }}>
                                    {stat.value}
                                </div>
                            </div>

                            <div className="text-gray-600 text-sm font-medium text-center w-full leading-relaxed">
                                <div dangerouslySetInnerHTML={{ __html: stat.title }} className="text-center" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};